export default "__VITE_ASSET__6d358981__"